<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <slot></slot>
    </div>
  </nav>
</template>
<script>
  export default {
    name: 'Navbar'
  }
</script>



// WEBPACK FOOTER //
// navbar.vue?c54a01ee